import { createStore, combineReducers } from 'redux'
import { abroad } from './reducers'

const appReducer = combineReducers({
  abroad,
})

const store = createStore(appReducer)

export default store
